import { render, staticRenderFns } from "./PL_Special.vue?vue&type=template&id=f45b2000&"
import script from "./PL_Special.vue?vue&type=script&lang=js&"
export * from "./PL_Special.vue?vue&type=script&lang=js&"
import style0 from "./PL_Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports